<template lang="pug">
div
  template(v-if="myTooltip.description")
    v-tooltip(bottom)
      template(v-slot:activator="{ on, attrs }")
        v-list-item(
          v-on="on" v-bind="attrs"
          v-if="!isHidden"
          :disabled="isDisabled"
          @click="onClick"
        )
          v-list-item-avatar.mr-2
            v-icon(
              :disabled="isDisabled"
              :class="myClazz",
              :color="myColor"
              small
            )
              | {{ myIcon || 'mdi-menu' }}

          v-list-item-content
            v-list-item-title.text-no-wrap(
              :class="myClazz",
              :color="myColor"
              :style="myStyle"
             )
              | {{ myTitle }}

          v-list-item-action.mr-2
            v-icon(
              v-if="myRightIcon"
              :disabled="isDisabled"
              :class="myClazz",
              :color="myColor"
              small
            )
              | {{ myRightIcon }}

      span(
        :class="myTooltip.clazz",
        :color="myTooltip.color",
        :style="myTooltip.style"
      )
        //- span.text-md.font-weight-medium {{ myTooltip.title }}
        //- br
        span.font-weight-light {{ myTooltip.description }}

  template(v-else)
    v-list-item(
      v-if="!isHidden"
      :disabled="isDisabled"
      @click="onClick"
    )
      v-list-item-avatar.mr-2
        v-icon(
          :disabled="isDisabled"
          :class="myClazz",
          :color="myColor"
          small
        )
          | {{ myIcon || 'mdi-menu' }}

      v-list-item-content
        v-list-item-title.text-no-wrap(
          :class="myClazz",
          :color="myColor"
          :style="myStyle"
         )
          | {{ myTitle }}

      v-list-item-action.mr-2
        v-icon(
          v-if="myRightIcon"
          :disabled="isDisabled"
          :class="myClazz",
          :color="myColor"
          small
        )
          | {{ myRightIcon }}

  </template>

  <script>
  import { selectOptions, selectClass, selectColor, selectFont } from '@/helpers/styles'
  import { parseEref } from '@/helpers/erefs'

  export default {
    props: {
      entity: Object,
      data: Object,
      row: Object,

      action: Object,

      // personalizações
      invisible: Boolean,
      hidden: Boolean,
      title: String,
      description: String,
      icon: String,
      rightIcon: String,
      color: String,
      font: String,
    },

    computed: {
      link() {
        return this.action || {}
      },

      context() {
        const { site, eref } = this.$route.params;
        return {
          site: site,
          eref: parseEref(eref),
          page: this.entity,
          data: this.data,
          row: this.row
        }
      },

      options() {
        const { link: action, context } = this
        return selectOptions([ action ], context)
      },

      // hasText() {
      //   return !this.icon || hasRel(this.pin, 'Text') || hasRel(this.link, 'Text')
      // },

      // hasIcon() {
      //   return this.icon
      // },

      isClickable() {
        return !!(this.$listeners.click || this.link.eref || this.link.href)
      },

      isDisabled() {
        return !!(this.invisible || this.options.disabled || this.options.invisible)
      },

      isHidden() {
        return !!(this.hidden || this.options.hidden)
      },

      // verb() {
      //   return this.link.verb || this.link.title || this.link.name || this.link.eref
      // },

      myTitle() {
        return this.title || this.link.title || this.link.verb || this.link.name || this.link.eref
      },

      myDescription() {
        return this.description || this.link.description
      },

      myIcon() {
        return this.icon || this.options.icon
      },

      myRightIcon() {
        return this.rightIcon
      },

      myColor() {
        return selectColor(this.color || this.options.style || this.options.color)
      },

      myClazz() {
        return selectClass(this.color || this.options.style || this.options.color)
      },

      myStyle() {
        return selectFont(this.font || this.options.font)
      },

      myTooltip() {
        const { myTitle: title, myDescription: description, link } = this
        const current = { title, description }

        const { entity: page, data, row } = this
        const options = selectOptions([ current, link.tooltip ], { page, data, row })

        return {
          title: options.title,
          description: options.description,
          color: selectColor('success' || options.color),
          clazz: selectClass(options.style || options.color),
          style: selectFont(options.font)
        }
      },
    },

    methods: {
      onClick(opts) {
        if (this.$listeners.click) {
          this.$emit('click', opts)
          return
        }

        const { link } = this
        if (link.eref || link.href) {
          this.$emit('perform', { link })
        }
      }
    }
  }
  </script>
